import { Services } from "../../api/Services";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CORPORATE_LOGO } from "../../api/Constants";
import { getImageUrl } from 'components/helpers/Helpers';
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

function ChangePassword() {
  const [password, setPassword] = useState("");
  const [cpassword, setCPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!oldPassword) {
      toast.error("Please Enter Old Password", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (!password) {
      toast.error("Please Enter New Password", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (!cpassword) {
      toast.error("Please Re-enter New Password", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (password !== cpassword) {
      toast.error("Re-enter Password Does Not Match With New Password", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (password.length < 6) {
      toast.error("Minimum Six Characters Required", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      setisLoading(true);
      try {
        const result = await Services.changePasswordd(
          encodeURIComponent(password),
          encodeURIComponent(cpassword),
          encodeURIComponent(oldPassword)
        );
        console.log(result);
        if (result.status === 200) {
          toast.success(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });

          setTimeout(() => {
            navigate("/trainer/");
          }, 2000);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
        setisLoading(false);
      } catch (error) {
        console.log(error);
        toast.error(error?.response?.data?.errors[0], {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    }
  };

  return (
    <div className="main-loging">
      {isLoading && (
        <div className="loaderparent">
          <div className="loader"></div>
        </div>
      )}
      <div className="login-wrapper">
        <ToastContainer />
        <div className="home">
          <div className="logo-image">
            <img src={CORPORATE_LOGO} alt="" />
          </div>
          <form onSubmit={handleSubmit}>
            <div className="home-form">
              <div className="form-group" style={{ position: 'relative' }}>
                <label>Enter Your Old Password</label>
                <input
                  type={showOldPassword ? 'text' : 'password'}
                  className="form-control input"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                />
               <span
                onClick={() => setShowOldPassword(!showOldPassword)}
                style={{
                  position: 'absolute',
                  top: '30px',
                  right: '10px',
                  cursor: 'pointer',
                  userSelect: 'none',
                  color: 'black'
                }}
              >
                {showOldPassword ? <AiOutlineEyeInvisible size={22} /> : <AiOutlineEye size={22} />}
              </span>
              </div>
              <div className="form-group" style={{ position: 'relative' }}>
                <label>Enter New Password</label>
                <input
                  type={showNewPassword ? 'text' : 'password'}
                  className="form-control input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                               <span
                onClick={() => setShowNewPassword(!showNewPassword)}
                style={{
                  position: 'absolute',
                  top: '30px',
                  right: '10px',
                  cursor: 'pointer',
                  userSelect: 'none',
                  color: 'black'
                }}
              >
                {showNewPassword ? <AiOutlineEyeInvisible size={22} /> : <AiOutlineEye size={22} />}
              </span>

              </div>
              <div className="form-group" style={{ position: 'relative' }}>
                <label>Re-enter Your New Password</label>
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  className="form-control input"
                  value={cpassword}
                  onChange={(e) => setCPassword(e.target.value)}
                />
                               <span
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                style={{
                  position: 'absolute',
                  top: '30px',
                  right: '10px',
                  cursor: 'pointer',
                  userSelect: 'none',
                  color: 'black'
                }}
              >
                {showConfirmPassword ? <AiOutlineEyeInvisible size={22} /> : <AiOutlineEye size={22} />}
              </span>
              </div>

              <div className="login-buttons">
                <button type="submit" className="button">
                  Change password
                </button>
                <Link to={"/trainer"} className="button forgot">
                  Go Back
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
